// extracted by mini-css-extract-plugin
export default {"title":"ModalPopup_title__O06E7"};